export const MOB_APP_BUTTON_MOUNT_POINT = 'mob-app-button-mount-point';
